import { useState, useEffect } from 'react';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/78577c8f-fc18-41aa-a1d2-c9f8c54ee764/78623651-928a-4a6c-9696-e83a35e6db95_13191140.jpg?v=33ccac5c6e145a69a497b2044c26fbdd';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-[#EDEAE5] transition-all duration-300">
      <div className="px-6 md:px-12 flex items-center justify-between h-[88px]">

        {/* Logo */}
        <a href="/" className="flex items-center cursor-pointer flex-shrink-0">
          <img
            src={LOGO_URL}
            alt="Culp Home Improvement LLC"
            className="h-16 w-auto object-contain"
            style={{ maxWidth: '220px' }}
          />
        </a>

        {/* Desktop CTAs */}
        <div className="hidden md:flex items-center gap-5">
          <a
            href="tel:5153215711"
            className="text-sm font-semibold text-[#2B2B2B] hover:text-[#B8956A] tracking-wide transition-colors duration-200 whitespace-nowrap flex items-center gap-2"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#B8956A]/10">
              <i className="ri-phone-fill text-[#B8956A] text-sm"></i>
            </div>
            515-321-5711
          </a>
          <button
            onClick={() => scrollTo('contact')}
            className="bg-[#B8956A] hover:bg-[#9a7a52] text-white text-sm font-bold px-8 py-3.5 tracking-[0.1em] uppercase transition-all duration-300 whitespace-nowrap cursor-pointer hover:-translate-y-px"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Get Estimate
          </button>
        </div>

        {/* Mobile */}
        <div className="md:hidden flex items-center gap-3">
          <a
            href="tel:5153215711"
            className="flex items-center justify-center w-10 h-10 rounded-full bg-[#B8956A]/10"
          >
            <i className="ri-phone-fill text-[#B8956A] text-lg"></i>
          </a>
          <button
            className="w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-2xl text-[#2B2B2B] ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-[#EDEAE5] px-6 py-5 flex flex-col gap-3">
          <a
            href="tel:5153215711"
            className="flex items-center justify-center gap-2 bg-[#1A1A1A] text-white text-sm font-bold px-5 py-4 whitespace-nowrap"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            <i className="ri-phone-fill text-[#B8956A]"></i> Tap to Call: 515-321-5711
          </a>
          <button
            onClick={() => scrollTo('contact')}
            className="bg-[#B8956A] text-white text-sm font-bold px-5 py-4 hover:bg-[#9a7a52] transition-colors cursor-pointer whitespace-nowrap"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Get Free Estimate
          </button>
        </div>
      )}
    </header>
  );
}
